/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class IconsRegistryConstants {
}
IconsRegistryConstants.GLOBAL_KEY = 'window.sirius.shared.iconsRegistry';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbnMtcmVnaXN0cnkuY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9pY29ucy9yZWdpc3RyeS9pY29ucy1yZWdpc3RyeS5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sc0JBQXNCOztBQUNSLGlDQUFVLEdBQUcsb0NBQW9DLENBQUMifQ==